import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Heart, Target, Users } from "lucide-react";

export default function About() {
  return (
    <div className="min-h-screen grain">
      <Navbar />
      <section className="max-w-5xl mx-auto px-4 sm:px-6 py-12">
        <div className="inline-block bg-[#F3E8E6] nb-border nb-shadow-sm px-3 py-1 mb-4 font-head font-bold text-xs uppercase tracking-widest">About us</div>
        <h1 className="font-head font-black text-5xl tracking-tighter mb-6">We bring dating back to the real world.</h1>
        <p className="text-lg text-gray-700 font-medium max-w-3xl">
          qrcupid was born from a simple frustration: meeting someone in real life and fumbling to exchange numbers. We built a personal QR code that instantly shares your dating profile — at bars, coffee shops, singles events, and networking nights.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
          {[
            { icon: Target, t: "Our Mission", d: "Make every real-world moment a chance to connect — no awkward exchanges.", c: "#8B1E3F", txt: "text-white" },
            { icon: Heart, t: "Our Belief", d: "Chemistry happens in person. Tech should just get out of the way.", c: "#D4AF37", txt: "" },
            { icon: Users, t: "Our Community", d: "Verified, safe and inclusive — for every kind of single.", c: "#F3E8E6", txt: "" },
          ].map((b, i) => (
            <div key={i} className={`nb-border nb-shadow p-6 ${b.txt}`} style={{ background: b.c }}>
              <b.icon className="w-8 h-8 mb-3" strokeWidth={2.5} />
              <h3 className="font-head font-black text-xl mb-2">{b.t}</h3>
              <p className="font-medium">{b.d}</p>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
